import { PlusIcon } from '@heroicons/react/outline'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addToCartProduct } from '../Redux/Action/catelog.action'
import { FormatAmount } from './FormatAmount'
import { Tooltip } from '@mui/material'
import NO_PHOTO from '../assets/nophoto.png'
const ShowProduct = ({ productData, handleClosePopup }) => {
    const dispatch = useDispatch()
    const { atcProduct } = useSelector((state) => state.catelogReducer)
    const { staffInfo, currency } = useSelector((state) => state.authReducer)
    const { discountInfo } = useSelector((state) => state.orderReducer)
    const location_id = localStorage.getItem('location_id')
    const currencyRate = currency && (currency?.find(c => c.name === staffInfo?.client?.currency_format)?.rate[0] ?? 1);
    const [grpvalue, setGrpvalue] = useState([]);
    const [selectVariant, setSelectVariant] = useState([])
    const [selectedVarData, setSelectedVarData] = useState({
        varImage: "",
        varPrice: "",
        varQuantity: "",
    });
    const [varId, setVarId] = useState("");
    const [displayImage, setDisplayImage] = useState('')
    const colorVariant = grpvalue?.filter(g => g.group_name === 'Color') ?? [];
    const otherVariant = grpvalue?.filter(g => g.group_name !== 'Color') ?? [];
    const displayVariant = (variants) => {
        if (!variants || !Array.isArray(variants) || variants.length === 0) return;

        const updatedGrpvalue = [...grpvalue];

        for (let variant of variants) {
            if (!variant?.group) continue;

            for (const groupItem of variant.group) {
                const existingGroup = updatedGrpvalue.find(
                    (item) => item.group_name === groupItem.group_name
                );

                if (existingGroup) {
                    const valueIndex = existingGroup.group_value?.indexOf(groupItem.group_value);

                    if (valueIndex === -1) {
                        existingGroup.group_value.push(groupItem.group_value);
                    }
                } else {
                    updatedGrpvalue.push({
                        group_name: groupItem.group_name,
                        group_value: [groupItem.group_value],
                        _id: groupItem._id,
                    });
                }
            }
        }

        setGrpvalue(updatedGrpvalue);
    };
    const resetAllStates = () => {
        setDisplayImage(null); // Reset image
        setVarId(null); // Reset variant ID
        setSelectVariant([]); // Reset selected variants
        setGrpvalue([]); // Reset group value
    };
    useEffect(() => {
        if (productData?.variants) {
            // Initialize variants and related states
            displayVariant(productData.variants);

            let defaultVar = productData.variants.find((x) => x.default === true);
            setDisplayImage(defaultVar?.image);
            setVarId(defaultVar?._id);
            setSelectVariant(defaultVar?.group ?? []);
        } else {
            // Reset state when productData is not present
            resetAllStates();
        }
    }, [productData, handleClosePopup]);
    const SelectVariant = useCallback(() => {
        let matchId;
        let matchPrice;
        let matchimg;
        let matchQuantity;

        if (productData?.variants) {
            const arraysMatch = (arr1, arr2) => {
                if (arr1?.length !== arr2?.length) {
                    return false;
                }

                for (let i = 0; i < arr1.length; i++) {
                    if (
                        arr1[i].group_name !== arr2[i].group_name ||
                        arr1[i].group_value !== arr2[i].group_value
                    ) {
                        return false;
                    }
                }
                return true;
            };

            const matchingGroup = productData?.variants?.find((obj) =>
                arraysMatch(obj.group, selectVariant)
            );

            if (matchingGroup) {
                matchId = matchingGroup._id;
                matchPrice = matchingGroup.price;
                matchimg = matchingGroup.image;
                matchQuantity = matchingGroup.quantity;

                setVarId((prevId) => (prevId !== matchId ? matchId : prevId));
                setDisplayImage((prevImage) => (prevImage !== matchimg ? matchimg : prevImage));
                setSelectedVarData((prevVariant) => {
                    if (
                        prevVariant.varImage !== matchimg ||
                        prevVariant.varPrice !== matchPrice ||
                        prevVariant.varQuantity !== matchQuantity
                    ) {
                        return {
                            varImage: matchimg,
                            varPrice: matchPrice,
                            varQuantity: matchQuantity,
                        };
                    }
                    return prevVariant;
                });
            } else {
                setSelectedVarData((prevVariant) => {
                    if (
                        prevVariant.varImage !== "" ||
                        prevVariant.varPrice !== "" ||
                        prevVariant.varQuantity !== ""
                    ) {
                        return {
                            varImage: "",
                            varPrice: "",
                            varQuantity: "",
                        };
                    }
                    return prevVariant;
                });
            }
        }
    }, [productData, selectVariant]);
    useEffect(() => {
        SelectVariant();
    }, [SelectVariant]);
    const addToCart = (e) => {
        e.stopPropagation();

        const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
            products: [],
            status: "completed",
            channel: "pos",
            pos_location: location_id,
            total_price: 0,
            sub_total: 0,
            adjust_discount: 0,
            adjust_discount_type: "amount",
        };

        // Check if the product already exists in the cart
        const existingProduct = cart.products?.some((item) => item.product === productData?._id);
        // Check if the specific variant of the product exists
        const existingVariantProduct = cart.products?.some(
            (item) => item.variant !== undefined && item.variant === varId
        );
        // Prevent adding the same product without variants
        if (existingProduct && productData?.variant?.length <= 0) {
            return;
        }

        if (existingVariantProduct) {
            return;
        }

        // Calculate return valid till date
        const date = new Date();
        date.setDate(date.getDate() + Number(productData?.product_replacement_days));
        cart.products.push({
            product: productData?._id,
            name: productData?.product_name,
            ...(varId?.length > 0 && { variant: varId }),
            image: selectedVarData?.varImage || productData?.additional_images?.[0],
            sku_id: productData?.sku_id,
            quantity: 1,
            selling_price: selectedVarData?.varPrice || (productData?.selling_price || productData?.mrp),
            mrp: productData?.mrp || productData?.selling_price,
            total_quantity: productData?.product_type === 'membership' ? 1 : (selectedVarData?.varQuantity || productData?.quantity),
            product_total: selectedVarData?.varPrice || (productData?.selling_price || productData?.mrp) * 1,
            product_type: productData?.product_type,
            dimension: productData?.dimension,
            weight: productData?.weight,
            product_return_policy: productData?.product_return_policy,
            product_replacement_days: productData?.product_replacement_days,
            ...(productData?.product_replacement_days > 0 && { return_valid_till_date: date }),
            is_return: productData?.is_return,
            cgst: productData?.cgst,
            sgst: productData?.sgst,
            group: productData?.variants?.find((item) => item._id === varId)?.group
        });

        const calculateTotalPrice = (products) =>
            products.reduce((total, product) => total + product.selling_price * product.quantity, 0);

        const calculateTotalDiscount = (total_price) => {
            if (!discountInfo || !discountInfo.productData) {
                return 0;
            }
            const { discount_Type, discount } = discountInfo.productData;
            if (discount_Type === "percentage") {
                return total_price * (discount / 100);
            }
            if (discount_Type === "amount") {
                return discount / currencyRate;
            }
            return 0;
        };

        const calculateAdjustDiscount = (currentTotalPrice) => {
            const { adjust_discount, adjust_discount_type } = cart;
            if (adjust_discount_type === "percentage") {
                return currentTotalPrice * (cart.adjust_discount_percentage / 100);
            }
            if (adjust_discount_type === "amount") {
                return adjust_discount / currencyRate;
            }

            return 0;
        };

        const calculateMembershipDiscount = () => {
            if (!cart?.pos_membership) {
                return 0;
            }
            const { pos_membership_discount_type, pos_membership_discount_percentage, pos_membership_discount } = cart;
            if (pos_membership_discount_type === "percentage") {
                return total_price * (pos_membership_discount_percentage / 100);
            }
            if (pos_membership_discount_type === "amount") {
                return pos_membership_discount / currencyRate;
            }
            return 0;
        };

        const total_price = calculateTotalPrice(cart.products);
        const discount = calculateTotalDiscount(total_price);
        const adjustDiscount = calculateAdjustDiscount(total_price - discount);
        const membershipDiscount = calculateMembershipDiscount();

        // Update cart totals
        cart.total_price = total_price - discount - adjustDiscount - membershipDiscount;
        cart.sub_total = total_price;
        cart.total_discount = discount;
        cart.adjust_discount = adjustDiscount;
        cart.adjust_discount_type = cart.adjust_discount_type || "amount";
        cart.cash_amount = 0;
        cart.pos_membership_discount = membershipDiscount;

        // Save updated cart
        localStorage.setItem("addToCart", JSON.stringify(cart));
        dispatch(addToCartProduct(cart));
        handleClosePopup();
    };    
    return (
        <div className='product-card cursor-pointer p-2'>
            <img src={displayImage || productData?.additional_images?.[0] || NO_PHOTO} alt={productData?.product_name} className='inline-block h-65 w-80 object-cover rounded max-h-full mb-4' />
            <div className='flex flex-col gap-2'>
                <p className='text-[18px] font-medium'>{`${productData?.product_name.substring(0, 25)}${productData?.product_name?.length > 25 ? '...' : ''}`}</p>
                <div className='flex gap-1 items-center justify-between flex-wrap'>
                    {productData?.variants?.length > 0 ? <p className="text-[20px] inline-block font-semibold">{FormatAmount(productData?.variants?.find((item) => item._id === varId)?.price, staffInfo?.client)}
                    </p>
                        :
                        <p className="text-[20px] inline-block font-semibold">{FormatAmount(productData?.selling_price ?? productData?.mrp ?? 0, staffInfo?.client)}
                        </p>}
                    {productData?.sku_id && <p className='text-[14px] inline-block info-text'>SKU : {productData?.sku_id}</p>}
                </div>
                {productData?.variants?.length > 0 && <div className='flex items-center gap-1'>
                    {colorVariant?.length > 0 &&
                        colorVariant.map((elem, index) => (
                            elem?.group_value?.map((item, i) => (
                                <div
                                    key={`${index}-${i}`}
                                    className='cursor-pointer inline-block border rounded-full p-[3px] border-transparent w-[30px] h-[30px] shadow-md'
                                    style={selectVariant?.some(x => x?.group_value === item) ? { borderColor: 'black' } : {}}
                                    onClick={() => {
                                        const matchgrp = grpvalue.find((x) => x.group_value.includes(item));
                                        if (matchgrp) {
                                            const updatedSelectVariant = selectVariant?.map((selected) => {
                                                if (selected.group_name === matchgrp.group_name) {
                                                    return {
                                                        ...selected,
                                                        group_value: item,
                                                    };
                                                }
                                                return selected;
                                            });
                                            setSelectVariant(updatedSelectVariant);
                                        }
                                    }}
                                >
                                <Tooltip title={item}>
                                    <div
                                        className="inline-block w-full h-full rounded-full"
                                        style={{ backgroundColor: item === 'white' ? '#e9e9e9' : item }}
                                    ></div>
                                </Tooltip>
                                </div>
                            ))
                        ))
                    }
                </div>}
                {productData?.variants?.length > 0 && otherVariant?.length > 0 &&
                    otherVariant.map((elem, index) => (
                        <div key={index} className="items-center gap-1">
                            <div className='text-[14px] font-medium'>{elem?.group_name}</div>
                            {elem?.group_value?.map((item, i) => (
                                <span
                                    key={i}
                                    className={`${selectVariant?.some(x => x?.group_value === item) ? '!bg-[#E9EEFA] !text-[#2457ca] !border !border-[#2457ca]' : ''} variant-bedge ml-2`}
                                    onClick={() => {
                                        const matchgrp = grpvalue.find((x) => x.group_value.includes(item));
                                        if (matchgrp) {
                                            const updatedSelectVariant = selectVariant?.map((selected) => {
                                                if (selected.group_name === matchgrp.group_name) {
                                                    return {
                                                        ...selected,
                                                        group_value: item,
                                                    };
                                                }
                                                return selected;
                                            });
                                            setSelectVariant(updatedSelectVariant);
                                        }
                                    }}
                                >
                                    <div className='flex items-center'>
                                        {item}
                                    </div>
                                </span>
                            ))}
                        </div>
                    ))
                }
                <button
                    disabled={(atcProduct?.products?.some(item => item?.product === productData?._id) && (!productData?.variants || productData?.variants.length === 0)) || atcProduct?.products?.some((item) => item.variant !== undefined && item.variant === varId)}
                    className={`${(atcProduct?.products?.some(item => item?.product === productData?._id) && (!productData?.variants || productData?.variants.length === 0)
                    ) || atcProduct?.products?.some((item) => item.variant !== undefined && item.variant === varId) ? '!bg-gray-500 cursor-not-allowed opacity-50' : ''} btn-primary mt-2`}
                    onClick={(e) => addToCart(e)}
                >
                    {(!atcProduct?.products?.some(item => item?.product === productData?._id) || !atcProduct?.products?.some((item) => item.variant !== undefined && item.variant === varId)) && <PlusIcon className='me-1 w-3 h-3' strokeWidth={3} />}
                    {`${((atcProduct?.products?.some(item => item?.product === productData?._id) && (!productData?.variants || productData?.variants.length === 0)) || atcProduct?.products?.some((item) => item.variant !== undefined && item.variant === varId)) ? 'Added' : 'Add To Cart'} `}
                </button>
            </div>
        </div>
    )
}

export default ShowProduct